export const API_BASE_URL = import.meta.env.VITE_API_URL || '';

// Multi-tenancy: Subsidiary code set at build time
// Used for pre-auth requests (login, register) before JWT is available
export const SUBSIDIARY_CODE = import.meta.env.VITE_SUBSIDIARY || 'nonpartisan';

// The canonical public origin of this build (e.g. https://app.votecivic.com), set per
// brand at build time. Use it for links handed to third parties — the donation page URL a
// campaign circulates and the iframe snippet they paste on their own site. Those must not
// capture whichever host an admin happened to be browsing: the app answers on more than one
// origin (the apex redirects to app.*), and only this one is durable. A cross-origin
// redirect later can also silently drop the Payment Request permission Apple Pay / Google
// Pay need inside the frame. Falls back to the current origin so local dev still works.
export const APP_ORIGIN =
  import.meta.env.VITE_APP_ORIGIN ||
  (typeof window !== 'undefined' ? window.location.origin : '');

export const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN || '';

// Meta (Facebook) ad pixel. Set per-brand at build time (e.g. .env.gop for the
// Republican warming pilot); empty on builds without a pixel, which disables it.
export const META_PIXEL_ID = import.meta.env.VITE_META_PIXEL_ID || '';

// Google Tag Manager container. Set per-brand at build time (e.g. .env.gop for the
// Republican warming pilot); empty on builds without a container, which disables it.
export const GTM_CONTAINER_ID = import.meta.env.VITE_GTM_CONTAINER_ID || '';